import request from '@/utils/request'

// 获取告警日志列表
export const getAlarmLogList = (data) => {
    return request({
        url: '/alarm/log/lists',
        params: data
    })
}

// 获取告警日志详情
export const getAlarmLogDetail = (id) => {
    return request({
        url: `/alarm/log/${id}`
    })
}

/**
 * 批量确认 , 取消
 * @param {*} type 处理的类型 batch_confirm 确认 batch_cancel取消
 * @param {*} data 确认的告警列表
 */
export const batchAlarmConfirmCancel = (type, data) => {
    return request({
        url: '/alarm/log/manage',
        method: 'PATCH',
        data: {
            method: type,
            data
        }
    })
}

// 一键确认该查询条件下的所有告警
export const batchConfirmAllAlarm = (data) => {
    return request({
        url: '/alarm/log/confirm',
        method: 'POST',
        data
    })
}
